import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "MODULES/users/actions";
import { useCurrentUser } from "APP_ROOT/hooks";

function EnableMfa(props) {
  const { user } = props;
  const currentUser = useCurrentUser();

  return (
    <div>
      {user.id === currentUser.id &&
        currentUser.tenant.mfa_enabled &&
        !user.mfa_enabled && (
          <button
            className="btn btn-primary pull-right"
            style={{ marginLeft: "20px" }}
            onClick={props.enableMfa}
          >
            <i className="fa fa-fw fa-phone" /> Enable Mfa
          </button>
        )}
    </div>
  );
}

EnableMfa.propTypes = {
  enableMfa: PropTypes.func.isRequired
};

export default connect(state => ({ user: state.userDetail.toJS().user }), {
  enableMfa: actions.enableMfa
})(EnableMfa);



// WEBPACK FOOTER //
// ./app/modules/users/components/EnableMfa/EnableMfa.jsx